module.exports = __webpack_public_path__ + "img/CATARINA.59c225cc.jpeg";